'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Back';
import EtablishmentForm from 'Components/Forms/Models/Etablishment/EtablishmentForm';
import Link from 'Pure/Link';
import { front_urls, URL } from 'Shared/Routes';
let app = typeof window !== 'undefined' ? window.app : undefined;
export default class NewEtablishmentPage extends Component {
  state = {
    roles: app.state.session.user?.roles || []
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
    if (app.state.session.fetched) {
      component.setState({
        roles: app.state.session.user?.roles || []
      });
    }
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
  }
  handleSessionChange = ({
    source,
    data
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      roles: app.state.session.user?.roles || []
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Nouvel \xE9tablissement"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content"
    }, /*#__PURE__*/React.createElement(Button, {
      component: Link,
      href: URL('AdminEtablishmentsDashboard', front_urls),
      className: "u-margin-bottom-15"
    }, '<', " Retour aux \xE9tablissements"), state.roles?.length > 0 ? /*#__PURE__*/React.createElement(EtablishmentForm, {
      roles: state.roles
    }) : undefined));
    return output;
  }
}
